import {lazy, StrictMode} from "react";
import {createRoot} from "react-dom/client";
import {Provider} from "react-redux";
import store from "./redux/store";

//scss
import "@/styles/scss/style.scss";
import "@/styles/scss/ark-ui.scss";
import {isProduction} from "@/config";
import "@/i18n/config";

const App = lazy(() => import("@/app"));

const mountNode = document.getElementById("root");
if (mountNode) {
    console.info(isProduction ? "PROD" : "DEV");
    if (isProduction && "serviceWorker" in navigator) {
        window.addEventListener("load", () => {
            navigator.serviceWorker.register("/sw.js", { scope: "/" })
                .then((r) => {
                    if (r.installing) {
                        console.info("Service Worker Registered");
                    }
                });
        });
    }

    const root = createRoot(mountNode); // createRoot(container!) if you use TypeScript
    root.render(
      <StrictMode>
          <Provider store={store} >
              <App/>
          </Provider>
      </StrictMode>
    );
} else {
    alert("Error mounting app");
}
